// 카드 (S.card + 헤더). props: title, count, right (헤더 우측 노드), children, pad (본문 padding, 기본 0), style (래퍼 보정)
// overflow:clip — 안의 장부 표 sticky 가 갇히지 않게 (hidden 금지).
import React from 'react';
import { S } from '../theme';

function Card(props) {
  var hasHead = props.title || props.count != null || props.right;
  return (<div className="v2-card" style={Object.assign({}, S.card, props.style)}>
    {hasHead ? <div style={S.cardHead}>
      {props.title ? <b style={S.cardTitle}>{props.title}</b> : null}
      {props.count != null ? <span style={S.cardCount}>{props.count}</span> : null}
      {props.right ? <span style={S.cardRight}>{props.right}</span> : null}
    </div> : null}
    <div style={props.pad ? { padding: props.pad } : undefined}>{props.children}</div>
  </div>);
}

export default Card;
